import { render } from "./AboutUs.vue?vue&type=template&id=ce5f3f1a&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=ce5f3f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5f3f1a"]])

export default __exports__